import React from "react";
import classnames from "classnames";
import Clickable, { ClickableAction } from "@unum/clickable";
import styles from "./Button.module.scss";

export type Rank = "primary" | "secondary" | "tertiary";
export type Theme =
  | "default"
  | "thin"
  | "arrow"
  | "inline"
  | "close"
  | "icon"
  | "ghost";

export type Props = {
  children: React.ReactNode;
  rank?: Rank;
  theme?: Theme;
  action?: ClickableAction;
  onClick?: () => void;
  className?: string;
  icon?: SVGImport;
};

const Button = ({
  children,
  rank = "primary",
  theme = "default",
  action,
  onClick,
  className,
  icon: Icon,
  ...rest
}: Props) => {
  return (
    <Clickable
      className={classnames(
        "button",
        styles["Button"],
        {
          [`button--${rank}`]:
            theme !== "arrow" &&
            theme !== "close" &&
            theme !== "icon" &&
            theme !== "ghost",
          [styles[`Button--${rank}Ghost`]]: theme === "ghost",
          "button--pill":
            theme !== "arrow" && theme !== "close" && theme !== "icon",
          "button--pill--thin": theme === "thin",
          [styles["Button--arrow"]]: theme === "arrow" || theme === "icon",
          [styles["Button--inline"]]: theme === "inline",
          [styles["Button--close"]]: theme === "close",
          [styles["Button--withIcon"]]: theme === "icon",
          [styles["Button--default"]]: theme === "default"
        },
        className
      )}
      onClick={() => {
        if (onClick) {
          onClick();
        }
      }}
      {...action}
      {...rest}
    >
      {theme === "icon" && Icon && (
        <span className={styles["icon-wrapper"]}>
          <Icon className={styles["icon"]} />
        </span>
      )}
      {children}
    </Clickable>
  );
};

export default Button;
